import { render, staticRenderFns } from "./top-image.vue?vue&type=template&id=71228123&scoped=true&"
import script from "./top-image.vue?vue&type=script&lang=js&"
export * from "./top-image.vue?vue&type=script&lang=js&"
import style0 from "./top-image.vue?vue&type=style&index=0&id=71228123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71228123",
  null
  
)

export default component.exports